export default {"top":"_0YPhY","bottom":"_4XIE8"};